
define("rv!templates/booking/paymentplan",[],function(){return { v:3,
  t:[ { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        type:"text/css",
        href:"/fe/css/responsive.css?v=1006" } },
    " ",
    { t:7,
      e:"div",
      a:{ "class":"book-review" },
      f:[ { t:4,
          f:[ { t:7,
              e:"div",
              a:{ style:"text-align: center;" },
              f:[ { t:7,
                  e:"img",
                  a:{ style:"margin-top: 200px; height: 120px;",
                    src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif" } } ] } ],
          n:50,
          r:"loading" },
        { t:4,
          n:51,
          f:[ { t:4,
              f:[ { t:8,
                  r:"bookingSuccess" } ],
              n:50,
              r:"showSuccess" },
            { t:4,
              n:51,
              f:[ { t:8,
                  r:"paymentPlan" } ],
              r:"showSuccess" } ],
          r:"loading" } ] },
    " " ],
  p:{ paymentPlan:[ { t:7,
        e:"div",
        a:{ "class":"payment-plan" },
        f:[ { t:4,
            n:53,
            f:[ { t:8,
                r:"messenger" } ],
            r:"data.GlobalMessenger" },
          " ",
          { t:4,
            f:[ { t:7,
                e:"a",
                a:{ "class":"btn btn-primary",
                  href:[ { t:2,
                      r:"LinkAccountUrl" } ],
                  "data-track":"ReviewBooking,LinkAccount_Top,Click,1" },
                f:[ "Link My Bank Account" ] },
              " ",
              { t:7,
                e:"br" },
              { t:7,
                e:"br" } ],
            n:50,
            x:{ r:[ "data.BankAccounts.length" ],
              s:"_0===0" } },
          " ",
          { t:4,
            f:[ { t:7,
                e:"div",
                a:{ "class":"btn-group btn-group-xs" },
                f:[ { t:4,
                    f:[ { t:7,
                        e:"button",
                        a:{ type:"button",
                          "class":[ "btn vacation-btn",
                            { t:4,
                              f:[ " ",
                                { t:4,
                                  f:[ "btn-danger" ],
                                  n:50,
                                  x:{ r:[ "Messenger.Errors.length" ],
                                    s:"_0>0" } },
                                { t:4,
                                  n:51,
                                  f:[ { t:4,
                                      n:50,
                                      x:{ r:[ "Messenger.Warnings.length" ],
                                        s:"_0>0" },
                                      f:[ "btn-warning" ] },
                                    { t:4,
                                      n:50,
                                      x:{ r:[ "Messenger.Warnings.length" ],
                                        s:"!(_0>0)" },
                                      f:[ "btn-primary" ] } ],
                                  x:{ r:[ "Messenger.Errors.length" ],
                                    s:"_0>0" } } ],
                              n:50,
                              x:{ r:[ "activeVacation",
                                  "." ],
                                s:"_0===_1" } } ],
                          title:[ { t:4,
                              f:[ "Currently Booking" ],
                              n:50,
                              r:"IsCurrentVacation" } ] },
                        v:{ click:"onVacationClick" },
                        f:[ { t:4,
                            f:[ { t:7,
                                e:"img",
                                a:{ "class":"vac-menu-img",
                                  src:[ { t:2,
                                      r:"StaticContentUrl" },
                                    "images/hotelphotos/no-image.png" ] } } ],
                            n:50,
                            x:{ r:[ "HotelImage" ],
                              s:"_0==\"\"||_0==null" } },
                          { t:4,
                            n:51,
                            f:[ { t:7,
                                e:"img",
                                a:{ "class":"vac-menu-img",
                                  src:[ { t:2,
                                      r:"HotelImage" } ] } } ],
                            x:{ r:[ "HotelImage" ],
                              s:"_0==\"\"||_0==null" } },
                          " ",
                          { t:2,
                            r:"PlanningData.VacationName" },
                          { t:4,
                            f:[ "*" ],
                            n:50,
                            r:"IsCurrentVacation" } ] } ],
                    n:52,
                    r:"data.Vacations" } ] } ],
            n:50,
            x:{ r:[ "data.Vacations.length" ],
              s:"_0>1" } },
          " ",
          { t:4,
            f:[ { t:4,
                f:[ { t:7,
                    e:"a",
                    a:{ href:[ { t:2,
                          x:{ r:[ "getDetailLink",
                              "PlanningData.DestinationInfo.DestinationSourceID",
                              "PlanningData.Provider",
                              "PlanningData.DestinationInfo.VRegion.RegionName",
                              "PlanningData.DestionationInfo.VRegion.RegionID" ],
                            s:"_0(_1,_2,{value:_3,id:_4})" } } ],
                      "class":"btn" },
                    f:[ { t:7,
                        e:"strong",
                        f:[ "Return to Room Selection" ] } ] } ],
                n:50,
                r:"data.CurrentlyBooking" } ],
            n:50,
            x:{ r:[ "activeVacation" ],
              s:"_0==null" } },
          { t:4,
            n:51,
            f:[ { t:4,
                f:[ { t:4,
                    n:53,
                    f:[ { t:8,
                        r:"messenger" } ],
                    r:"activeVacation.Messenger" },
                  " ",
                  { t:7,
                    e:"div",
                    a:{ "class":"row" },
                    f:[ { t:7,
                        e:"div",
                        a:{ "class":"span8" },
                        f:[ " ",
                          { t:7,
                            e:"table",
                            a:{ "class":"table table-bordered LeftComponent diffOffset" },
                            f:[ { t:7,
                                e:"thead",
                                f:[ { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td",
                                        a:{ colspan:"2" },
                                        f:[ { t:7,
                                            e:"strong",
                                            f:[ "Reservation Costs" ] } ] } ] } ] },
                              " ",
                              { t:7,
                                e:"tbody",
                                a:{ style:"display: table-row-group;" },
                                f:[ { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td",
                                        f:[ "Room Cost ",
                                          { t:7,
                                            e:"a",
                                            a:{ href:"#rate",
                                              "class":"infoLink",
                                              "data-track":"ReviewBooking,Help,RoomCost,1" },
                                            f:[ { t:7,
                                                e:"img",
                                                a:{ "class":"right",
                                                  src:[ { t:2,
                                                      r:"StaticContentUrl" },
                                                    "images/ico-question.png" ],
                                                  alt:"what's this" } } ] },
                                          " ",
                                          { t:7,
                                            e:"div",
                                            a:{ id:"rate",
                                              "class":"infoBox" },
                                            f:[ "This is the total cost of your booking. ",
                                              { t:7,
                                                e:"br" },
                                              { t:7,
                                                e:"br" },
                                              " ",
                                              { t:8,
                                                r:"nightlyRates" },
                                              " ",
                                              { t:8,
                                                r:"chatWithUs" } ] } ] },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        a:{ "class":"right" },
                                        f:[ { t:7,
                                            e:"a",
                                            a:{ href:"#roomCostDetails",
                                              "class":"infoLink sideNote",
                                              "data-track":"ReviewBooking,Help,RoomCost_Details,1" },
                                            f:[ "details" ] },
                                          "    ",
                                          { t:7,
                                            e:"div",
                                            a:{ id:"roomCostDetails",
                                              "class":"infoBox" },
                                            f:[ { t:8,
                                                r:"nightlyRates" },
                                              " ",
                                              { t:8,
                                                r:"chatWithUs" } ] },
                                          " Rate: ",
                                          { t:7,
                                            e:"strong",
                                            f:[ { t:2,
                                                x:{ r:[ "formatMoney",
                                                    "PlanningData.DestinationInfo.Rate.RoomRateTotal" ],
                                                  s:"_0(_1)" } } ] } ] } ] },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td",
                                            f:[ "Resort Fees ",
                                              { t:7,
                                                e:"a",
                                                a:{ href:"#resortFee",
                                                  "class":"infoLink",
                                                  "data-track":"ReviewBooking,Help,ResortFees,1" },
                                                f:[ { t:7,
                                                    e:"img",
                                                    a:{ "class":"right",
                                                      src:[ { t:2,
                                                          r:"StaticContentUrl" },
                                                        "images/ico-question.png" ],
                                                      alt:"what's this" } } ] },
                                              " ",
                                              { t:7,
                                                e:"div",
                                                a:{ id:"resortFee",
                                                  "class":"infoBox" },
                                                f:[ "This is any special fees associated with this resort. ",
                                                  { t:8,
                                                    r:"chatWithUs" } ] } ] },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            a:{ "class":"right" },
                                            f:[ "Charge: ",
                                              { t:7,
                                                e:"strong",
                                                f:[ { t:2,
                                                    x:{ r:[ "formatMoney",
                                                        "PlanningData.DestinationInfo.Rate.HotelFeeTotal" ],
                                                      s:"_0(_1)" } } ] } ] } ] } ],
                                    n:50,
                                    x:{ r:[ "formatMoney",
                                        "PlanningData.DestinationInfo.Rate.HotelFeeTotal" ],
                                      s:"_0(_1)!=\"$0.00\"" } },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td",
                                        f:[ "Hotel Tax Pass Through ",
                                          { t:7,
                                            e:"a",
                                            a:{ href:"#taxFee",
                                              "class":"infoLink",
                                              "data-track":"ReviewBooking,Help,Tax,1" },
                                            f:[ { t:7,
                                                e:"img",
                                                a:{ "class":"right",
                                                  src:[ { t:2,
                                                      r:"StaticContentUrl" },
                                                    "images/ico-question.png" ],
                                                  alt:"what's this" } } ] },
                                          " ",
                                          { t:7,
                                            e:"div",
                                            a:{ id:"taxFee",
                                              "class":"infoBox" },
                                            f:[ "This is the cost of taxes for this booking. Taxes are not matched and must be paid for separately. ",
                                              { t:8,
                                                r:"chatWithUs" } ] } ] },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        a:{ "class":"right" },
                                        f:[ "Tax: ",
                                          { t:7,
                                            e:"strong",
                                            f:[ { t:2,
                                                x:{ r:[ "formatMoney",
                                                    "PlanningData.DestinationInfo.Rate.HotelTaxFeeTotal" ],
                                                  s:"_0(_1)" } } ] } ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td" },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        a:{ "class":"right" },
                                        f:[ "Total: ",
                                          { t:7,
                                            e:"strong",
                                            f:[ { t:2,
                                                x:{ r:[ "formatMoney",
                                                    "TotalCost" ],
                                                  s:"_0(_1)" } } ] } ] } ] } ] } ] },
                          " ",
                          { t:4,
                            f:[ { t:7,
                                e:"div",
                                a:{ "class":"alert alert-warning vacation-review-alert",
                                  role:"alert" },
                                f:[ { t:7,
                                    e:"div",
                                    v:{ click:"showAgreeToFeesModal" },
                                    a:{ style:"display: inline;" },
                                    f:[ { t:7,
                                        e:"input",
                                        a:{ id:"chkAgreedToFees",
                                          type:"checkbox",
                                          checked:[ { t:2,
                                              r:"AgreedToFees" } ] },
                                        m:[ { t:4,
                                            f:[ "disabled" ],
                                            n:50,
                                            x:{ r:[ "IsCurrentVacation" ],
                                              s:"!_0" } } ] },
                                      " ",
                                      { t:7,
                                        e:"label",
                                        a:{ style:"color: #353535; font-weight: bold;" },
                                        f:[ "At check-in, you are required to pay directly to the property ",
                                          { t:2,
                                            x:{ r:[ "formatMoney",
                                                "PlanningData.DestinationInfo.Rate.HotelExcludedTax" ],
                                              s:"_0(_1)" } },
                                          " with your credit/debit card for ",
                                          { t:2,
                                            x:{ r:[ "PlanningData.DestinationInfo.Rate.HotelExcludedNote" ],
                                              s:"_0?_0:\"additional charges\"" } },
                                          ". You cannot use your Adestinn savings to pay any of these charges." ] },
                                      " ",
                                      { t:7,
                                        e:"a",
                                        a:{ href:"#extra-charges-question-modal",
                                          "class":"infoLink",
                                          "data-track":"ReviewBooking,Help,ResortFees,1" },
                                        f:[ { t:7,
                                            e:"img",
                                            a:{ src:[ { t:2,
                                                  r:"StaticContentUrl" },
                                                "images/ico-question.png" ],
                                              alt:"what's this" } } ] },
                                      " ",
                                      { t:4,
                                        f:[ { t:7,
                                            e:"ul",
                                            a:{ style:"list-style-type: disc; margin: 10px 0 10px 25px;" },
                                            f:[ { t:4,
                                                f:[ { t:7,
                                                    e:"li",
                                                    f:[ { t:4,
                                                        f:[ { t:2,
                                                            x:{ r:[ "formatMoney",
                                                                "Amount" ],
                                                              s:"_0(_1,false)" } } ],
                                                        n:50,
                                                        x:{ r:[ "Currency" ],
                                                          s:"_0!=null&&_0!=\"USD\"" } },
                                                      { t:4,
                                                        n:51,
                                                        f:[ { t:2,
                                                            x:{ r:[ "formatMoney",
                                                                "Amount" ],
                                                              s:"_0(_1)" } } ],
                                                        x:{ r:[ "Currency" ],
                                                          s:"_0!=null&&_0!=\"USD\"" } },
                                                      " - ",
                                                      { t:4,
                                                        f:[ { t:2,
                                                            r:"Subtype" } ],
                                                        n:50,
                                                        x:{ r:[ "Subtype" ],
                                                          s:"_0!=null" } },
                                                      { t:4,
                                                        n:51,
                                                        f:[ "Type Not Provided" ],
                                                        x:{ r:[ "Subtype" ],
                                                          s:"_0!=null" } },
                                                      " ",
                                                      { t:4,
                                                        f:[ { t:7,
                                                            e:"span",
                                                            a:{ style:"font-weight: bold;" },
                                                            f:[ "(",
                                                              { t:2,
                                                                r:"Currency" },
                                                              ")" ] } ],
                                                        n:50,
                                                        x:{ r:[ "Currency" ],
                                                          s:"_0!=null&&_0!=\"USD\"" } } ] } ],
                                                n:52,
                                                r:"PlanningData.DestinationInfo.Rate.HotelExcludedTaxes" } ] } ],
                                        n:50,
                                        x:{ r:[ "PlanningData.Provider" ],
                                          s:"_0==1" } } ] } ] },
                              " ",
                              { t:7,
                                e:"div",
                                a:{ id:"extra-charges-question-modal",
                                  "class":"infoBox ps-infobox" },
                                f:[ "Some properties have extra charges such as resort fees and miscellaneous taxes. These must be paid directly to the property at check-in. You cannot use your Adestinn savings to pay any of these charges. The amount shown here is an estimate based on the information available at the time of booking. The actual amount may vary at time of check-in." ] } ],
                            n:50,
                            x:{ r:[ "formatMoney",
                                "PlanningData.DestinationInfo.Rate.HotelExcludedTax" ],
                              s:"_0(_1)!=\"$0.00\"" } },
                          " ",
                          { t:4,
                            f:[ { t:7,
                                e:"table",
                                a:{ "class":"table table-bordered LeftComponent diffOffset" },
                                f:[ { t:7,
                                    e:"thead",
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td",
                                            a:{ colspan:"2" },
                                            f:[ { t:7,
                                                e:"strong",
                                                f:[ "Cancellation Policies" ] },
                                              " ",
                                              { t:7,
                                                e:"span",
                                                a:{ style:"float: right; font-style:italic; font-size: 12px;" },
                                                f:[ "*All times are based in the hotels timezone" ] } ] } ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tbody",
                                    f:[ { t:4,
                                        f:[ { t:7,
                                            e:"tr",
                                            f:[ { t:7,
                                                e:"td",
                                                m:[ { t:4,
                                                    f:[ "class=\"cancellation-highlight\"" ],
                                                    n:50,
                                                    r:".Highlight" } ],
                                                f:[ "If cancelled on or after: ",
                                                  { t:7,
                                                    e:"strong",
                                                    f:[ { t:2,
                                                        x:{ r:[ "moment",
                                                            ".FromUTC",
                                                            ".OffsetUTC" ],
                                                          s:"_0.utc(_1).utcOffset(_2).format(\"MM/DD/YYYY hh:mm A\")" } } ] },
                                                  " ",
                                                  { t:7,
                                                    e:"a",
                                                    a:{ href:"#cancellation-price-modal",
                                                      "class":"infoLink" },
                                                    f:[ { t:7,
                                                        e:"img",
                                                        a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                                                          alt:"cancellation price information" } } ] } ] },
                                              " ",
                                              { t:7,
                                                e:"td",
                                                m:[ { t:4,
                                                    f:[ "class=\"cancellation-highlight right\"" ],
                                                    n:50,
                                                    r:".Highlight" },
                                                  { t:4,
                                                    n:51,
                                                    f:[ "class=\"right\"" ],
                                                    r:".Highlight" } ],
                                                f:[ { t:7,
                                                    e:"strong",
                                                    f:[ { t:2,
                                                        x:{ r:[ "formatMoney",
                                                            ".Amount" ],
                                                          s:"_0(_1)" } } ] } ] } ] } ],
                                        n:52,
                                        r:"PlanningData.DestinationInfo.Rate.CancellationPolicies" },
                                      " ",
                                      { t:7,
                                        e:"div",
                                        a:{ id:"cancellation-price-modal",
                                          "class":"infoBox ps-infobox" },
                                        f:[ "If this booking is canceled on or after the date show, the property will impose a cancellation penalty on this booking in the amount shown. This will be automatically subtracted from your VSA balance. ",
                                          { t:7,
                                            e:"br" },
                                          { t:7,
                                            e:"br" },
                                          " Non-refundable vacations cannot be canceled at any time and must be fully funded." ] } ] } ] } ],
                            n:50,
                            x:{ r:[ "PlanningData.DestinationInfo.Rate.CancellationPolicies.length" ],
                              s:"_0>0" } },
                          { t:4,
                            n:51,
                            f:[ { t:4,
                                f:[ { t:7,
                                    e:"table",
                                    a:{ "class":"table table-bordered LeftComponent diffOffset" },
                                    f:[ { t:7,
                                        e:"thead",
                                        f:[ { t:7,
                                            e:"tr",
                                            f:[ { t:7,
                                                e:"td",
                                                a:{ colspan:"2" },
                                                f:[ { t:7,
                                                    e:"strong",
                                                    f:[ "Cancellation Policies" ] },
                                                  " ",
                                                  { t:7,
                                                    e:"span",
                                                    a:{ style:"float: right; font-style:italic; font-size: 12px;" },
                                                    f:[ "*All times are based in the hotels timezone" ] } ] } ] } ] },
                                      " ",
                                      { t:7,
                                        e:"tbody",
                                        f:[ { t:7,
                                            e:"tr",
                                            f:[ { t:7,
                                                e:"td",
                                                a:{ "class":"cancellation-highlight" },
                                                f:[ { t:7,
                                                    e:"strong",
                                                    f:[ "This vacation is non-refundable" ] },
                                                  " ",
                                                  { t:7,
                                                    e:"a",
                                                    a:{ href:"#cancellation-price-modal-no-cancellation",
                                                      "class":"infoLink" },
                                                    f:[ { t:7,
                                                        e:"img",
                                                        a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                                                          alt:"cancellation price information" } } ] } ] } ] },
                                          " ",
                                          { t:7,
                                            e:"div",
                                            a:{ id:"cancellation-price-modal-no-cancellation",
                                              "class":"infoBox ps-infobox" },
                                            f:[ "If this booking is canceled on or after the date show, the property will impose a cancellation penalty on this booking in the amount shown. This will be automatically subtracted from your VSA balance. ",
                                              { t:7,
                                                e:"br" },
                                              { t:7,
                                                e:"br" },
                                              " Non-refundable vacations cannot be canceled at any time and must be fully funded." ] } ] } ] } ],
                                n:50,
                                x:{ r:[ "PlanningData.Provider" ],
                                  s:"_0==1" } } ],
                            x:{ r:[ "PlanningData.DestinationInfo.Rate.CancellationPolicies.length" ],
                              s:"_0>0" } },
                          " ",
                          { t:7,
                            e:"table",
                            a:{ "class":"table table-bordered diffOffset LeftComponent spaced" },
                            f:[ { t:7,
                                e:"thead",
                                f:[ { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td",
                                        a:{ colspan:"2" },
                                        f:[ { t:7,
                                            e:"strong",
                                            f:[ "Payment Details" ] } ] } ] } ] },
                              " ",
                              { t:7,
                                e:"tbody",
                                f:[ { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td",
                                            f:[ "Annual Deposit ",
                                              { t:7,
                                                e:"a",
                                                a:{ "data-track":"ReviewBooking,Help,AnnualDeposit,1",
                                                  href:"#annual",
                                                  "class":"infoLink" },
                                                f:[ { t:7,
                                                    e:"img",
                                                    a:{ "class":"right",
                                                      src:[ { t:2,
                                                          r:"StaticContentUrl" },
                                                        "images/ico-question.png" ],
                                                      alt:"what's this" } } ] },
                                              " ",
                                              { t:7,
                                                e:"div",
                                                a:{ id:"annual",
                                                  "class":"infoBox" },
                                                f:[ "Annual deposit is not matched, but it can be spent on vacations, as shown here. ",
                                                  { t:8,
                                                    r:"chatWithUs" } ] } ] },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            a:{ "class":"right" },
                                            f:[ "Deposits Used: ",
                                              { t:7,
                                                e:"strong",
                                                f:[ { t:2,
                                                    x:{ r:[ "formatMoney",
                                                        "PaymentPlan.AnnualDeposit" ],
                                                      s:"_0(_1)" } } ] } ] } ] } ],
                                    n:50,
                                    x:{ r:[ "PaymentPlan.AnnualDeposit" ],
                                      s:"_0>0" } },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td",
                                            f:[ "Contributions ",
                                              { t:7,
                                                e:"a",
                                                a:{ "data-track":"ReviewBooking,Help,Contributions,1",
                                                  href:"#contributions",
                                                  "class":"infoLink" },
                                                f:[ { t:7,
                                                    e:"img",
                                                    a:{ "class":"right",
                                                      src:[ { t:2,
                                                          r:"StaticContentUrl" },
                                                        "images/ico-question.png" ],
                                                      alt:"what's this" } } ] },
                                              " ",
                                              { t:7,
                                                e:"div",
                                                a:{ id:"contributions",
                                                  "class":"infoBox" },
                                                f:[ "Contributions are matched at ",
                                                  { t:2,
                                                    r:"data.MatchPercent" },
                                                  "%. To fund vacations, we use what's currently in your account and future scheduled contributions. ",
                                                  { t:8,
                                                    r:"chatWithUs" } ] } ] },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            a:{ "class":"right" },
                                            f:[ "Your Contributions: ",
                                              { t:7,
                                                e:"strong",
                                                f:[ { t:2,
                                                    x:{ r:[ "formatMoney",
                                                        "PaymentPlan.Contribution" ],
                                                      s:"_0(_1)" } } ] } ] } ] } ],
                                    n:50,
                                    x:{ r:[ "PaymentPlan.Contribution" ],
                                      s:"_0>0" } },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td",
                                            f:[ "Match ",
                                              { t:7,
                                                e:"a",
                                                a:{ href:"#match",
                                                  "data-track":"ReviewBooking,Help,Match,1",
                                                  "class":"infoLink" },
                                                f:[ { t:7,
                                                    e:"img",
                                                    a:{ "class":"right",
                                                      src:[ { t:2,
                                                          r:"StaticContentUrl" },
                                                        "images/ico-question.png" ],
                                                      alt:"what's this" } } ] },
                                              " ",
                                              { t:7,
                                                e:"div",
                                                a:{ id:"match",
                                                  "class":"infoBox" },
                                                f:[ "Match is where Adestinn comes in... ",
                                                  { t:8,
                                                    r:"chatWithUs" } ] } ] },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            a:{ "class":"right" },
                                            f:[ { t:2,
                                                r:"data.MatchPercent" },
                                              "% Match: ",
                                              { t:7,
                                                e:"strong",
                                                f:[ { t:2,
                                                    x:{ r:[ "formatMoney",
                                                        "PaymentPlan.Match" ],
                                                      s:"_0(_1)" } } ] } ] } ] } ],
                                    n:50,
                                    x:{ r:[ "PaymentPlan.Match" ],
                                      s:"_0>0" } },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        a:{ runat:"server" },
                                        f:[ { t:7,
                                            e:"td",
                                            f:[ "Bonus/Rebate" ] },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            a:{ "class":"right" },
                                            f:[ "Rebate Used: ",
                                              { t:7,
                                                e:"strong",
                                                f:[ { t:2,
                                                    x:{ r:[ "formatMoney",
                                                        "PaymentPlan.Rebate" ],
                                                      s:"_0(_1)" } } ] } ] } ] } ],
                                    n:50,
                                    x:{ r:[ "PaymentPlan.Rebate" ],
                                      s:"_0>0" } },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td",
                                            f:[ "Tax Pass Through",
                                              { t:7,
                                                e:"sup",
                                                a:{ style:"color:red;" },
                                                f:[ "*" ] },
                                              " ",
                                              { t:7,
                                                e:"a",
                                                a:{ href:"#taxPassthrough",
                                                  "data-track":"ReviewBooking,Help,Tax_Payment,1",
                                                  "class":"infoLink" },
                                                f:[ { t:7,
                                                    e:"img",
                                                    a:{ "class":"right",
                                                      src:[ { t:2,
                                                          r:"StaticContentUrl" },
                                                        "images/ico-question.png" ],
                                                      alt:"what's this" } } ] },
                                              " ",
                                              { t:7,
                                                e:"div",
                                                a:{ id:"taxPassthrough",
                                                  "class":"infoBox" },
                                                f:[ "Taxes are not matched and must be paid for separately.",
                                                  { t:7,
                                                    e:"br" },
                                                  { t:7,
                                                    e:"sup",
                                                    a:{ style:"color:red;" },
                                                    f:[ "*" ] },
                                                  "Tax amount may change at time of check-out.",
                                                  { t:7,
                                                    e:"br" },
                                                  "If needed, an adjustment will be made to your VSA. ",
                                                  { t:8,
                                                    r:"chatWithUs" } ] } ] },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            a:{ "class":"right" },
                                            f:[ "Used: ",
                                              { t:7,
                                                e:"strong",
                                                f:[ { t:2,
                                                    x:{ r:[ "formatMoney",
                                                        "PaymentPlan.TaxPassThrough" ],
                                                      s:"_0(_1)" } } ] } ] } ] } ],
                                    n:50,
                                    x:{ r:[ "PaymentPlan.TaxPassThrough" ],
                                      s:"_0>0" } },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td" },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        a:{ "class":"right" },
                                        f:[ "Total: ",
                                          { t:7,
                                            e:"strong",
                                            f:[ { t:2,
                                                x:{ r:[ "formatMoney",
                                                    "PaymentPlan.Total" ],
                                                  s:"_0(_1)" } } ] } ] } ] } ] } ] },
                          " ",
                          { t:4,
                            f:[ { t:7,
                                e:"table",
                                a:{ "class":"table table-bordered diffOffset LeftComponent spaced" },
                                f:[ { t:7,
                                    e:"thead",
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td",
                                            a:{ colspan:"2" },
                                            f:[ { t:7,
                                                e:"strong",
                                                f:[ "Special Requests" ] },
                                              " ",
                                              { t:7,
                                                e:"a",
                                                a:{ href:"#specialRequests",
                                                  "class":"infoLink" },
                                                f:[ { t:7,
                                                    e:"img",
                                                    a:{ "class":"right",
                                                      src:[ { t:2,
                                                          r:"StaticContentUrl" },
                                                        "images/ico-question.png" ],
                                                      alt:"what's this" } } ] },
                                              " ",
                                              { t:7,
                                                e:"div",
                                                a:{ id:"specialRequests",
                                                  "class":"infoBox" },
                                                f:[ "All requests are provided to the property and are NOT guaranteed. It is up to the property to determine if they are able to accommodate requests." ] } ] } ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tbody",
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"textarea",
                                            a:{ value:[ { t:2,
                                                  r:"SpecialRequests" } ],
                                              placeholder:"Request or inform the hotelier of a special request e.g. 'Twin bed please' or 'Non-smoking room preferred'.",
                                              style:"width:95%;margin:10px auto;display:block;resize:vertical;max-height:400px;" },
                                            m:[ { t:4,
                                                f:[ "disabled" ],
                                                n:50,
                                                x:{ r:[ "IsCurrentVacation" ],
                                                  s:"!_0" } } ] } ] } ] } ] } ],
                            n:50,
                            x:{ r:[ "PlanningData.Provider",
                                "provider.Hotelbeds",
                                "IsCurrentVacation",
                                "SpecialRequests" ],
                              s:"_0==_1&&_2||(!_2&&_3)" } },
                          " ",
                          { t:4,
                            f:[ { t:7,
                                e:"div",
                                a:{ id:"PerfectSaverRecalculation",
                                  "class":"infoBox" },
                                f:[ "Your payment plan is recalculated for all future vacations whenever you book another vacation, change your schedule or cancel a vacation so that you're always saving the perfect amount." ] },
                              " ",
                              { t:7,
                                e:"div",
                                a:{ "class":"LeftComponent overages shadowed spaced" },
                                f:[ { t:7,
                                    e:"a",
                                    a:{ href:"#PerfectSaverRecalculation",
                                      "data-track":"ReviewBooking,Help,PerfectSaverRecalculation,1",
                                      "class":"infoLink" },
                                    f:[ { t:7,
                                        e:"img",
                                        a:{ src:[ { t:2,
                                              r:"StaticContentUrl" },
                                            "images/destinationimages/page/perfectsaver_purple_nospace.png?v=2" ],
                                          alt:"PerfectSaver" } } ] },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"div",
                                        a:{ "class":"overage" },
                                        f:[ { t:7,
                                            e:"h4",
                                            a:{ "class":"spaced" },
                                            f:[ "In addition to your ",
                                              { t:2,
                                                x:{ r:[ "formatMoney",
                                                    "data.Schedule.Amount" ],
                                                  s:"_0(_1)" } },
                                              " ",
                                              { t:2,
                                                r:"data.Schedule.Type" },
                                              " contribution schedule:" ] },
                                          " ",
                                          { t:4,
                                            f:[ { t:4,
                                                n:53,
                                                f:[ { t:8,
                                                    r:"overageOptions" } ],
                                                x:{ r:[ ".",
                                                    "data.BankAccounts",
                                                    "data.Vacations.length" ],
                                                  s:"{vacation:_0,forTax:false,bankAccounts:_1,multipleVacations:_2>1}" } } ],
                                            n:52,
                                            r:"overageVacations" } ] } ],
                                    n:50,
                                    r:"hasNonTaxOverages" },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"div",
                                        a:{ "class":"overage" },
                                        f:[ { t:7,
                                            e:"h4",
                                            a:{ "class":"spaced" },
                                            f:[ "Taxes must be funded" ] },
                                          " ",
                                          { t:4,
                                            f:[ { t:4,
                                                n:53,
                                                f:[ { t:8,
                                                    r:"overageOptions" } ],
                                                x:{ r:[ ".",
                                                    "data.BankAccounts",
                                                    "data.Vacations.length" ],
                                                  s:"{vacation:_0,forTax:true,bankAccounts:_1,multipleVacations:_2>1}" } } ],
                                            n:52,
                                            r:"overageVacations" } ] } ],
                                    n:50,
                                    r:"hasTaxOverages" } ] } ],
                            n:50,
                            x:{ r:[ "IsCurrentVacation",
                                "data.CurrentlyBooking",
                                "overageVacations.length" ],
                              s:"(_0||!_1)&&_2>0" } },
                          " ",
                          { t:7,
                            e:"div",
                            a:{ "class":"alert alert-info vacation-review-alert" },
                            f:[ { t:7,
                                e:"h4",
                                f:[ "Policies" ] },
                              " ",
                              { t:3,
                                x:{ r:[ "getPolicy",
                                    "." ],
                                  s:"_0(_1)" } },
                              " ",
                              { t:7,
                                e:"p",
                                f:[ "The total above includes only the cost of the room, taxes and any mandatory resort fees the hotel charges." ] },
                              " ",
                              { t:7,
                                e:"p",
                                f:[ { t:7,
                                    e:"sup",
                                    a:{ style:"color:red;" },
                                    f:[ "*" ] },
                                  " Taxes are estimated at the time of booking based on the current tax information provided by the property. If the tax amount changes by check out, we will adjust your VSA accordingly." ] },
                              " Any incidental charges you incur such as room service, mini-bar, movies, spa services, parking, and others are not included in the above total. All hotels require a credit or debit card at check-in (contact the property's front desk to find out about their hold policy). A hold (of one night stay up to the full amount, depending on each property's policy) will be placed on your card and will come off at check-out (may take up to 10 business days if you use a debit card). Contact member services if you need more information." ] },
                          " ",
                          { t:4,
                            f:[ { t:7,
                                e:"div",
                                a:{ "class":"spaced" },
                                f:[ { t:7,
                                    e:"input",
                                    a:{ id:"chkAgreedToPolicies",
                                      type:"checkbox",
                                      checked:[ { t:2,
                                          r:"AgreedToPolicies" } ] } },
                                  " ",
                                  { t:7,
                                    e:"label",
                                    a:{ "for":"chkAgreedToPolicies",
                                      "class":"large-label" },
                                    f:[ "Agree to Hotel Policies" ] } ] } ],
                            n:50,
                            r:"IsCurrentVacation" } ] },
                      " ",
                      { t:7,
                        e:"div",
                        a:{ id:"bookHotelImage",
                          "class":"span4" },
                        f:[ { t:4,
                            f:[ { t:7,
                                e:"img",
                                a:{ "class":"shadowed",
                                  style:"width: 100%; height: 100%;",
                                  src:[ { t:2,
                                      r:"StaticContentUrl" },
                                    "images/hotelphotos/no-image.png" ],
                                  "data-original":[ { t:2,
                                      r:"RoomImage" } ],
                                  alt:"no room image" } } ],
                            n:50,
                            x:{ r:[ "HotelImage" ],
                              s:"_0==\"\"||_0==null" } },
                          { t:4,
                            n:51,
                            f:[ { t:7,
                                e:"img",
                                a:{ "class":"shadowed",
                                  src:[ { t:2,
                                      r:"HotelImage" } ],
                                  alt:"room image" } } ],
                            x:{ r:[ "HotelImage" ],
                              s:"_0==\"\"||_0==null" } },
                          " ",
                          { t:7,
                            e:"br" },
                          " ",
                          { t:7,
                            e:"table",
                            a:{ "class":"table table-bordered diffOffset spaced" },
                            f:[ { t:7,
                                e:"thead",
                                f:[ { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td",
                                        a:{ colspan:"2" },
                                        f:[ { t:7,
                                            e:"strong",
                                            f:[ "Itinerary" ] } ] } ] } ] },
                              " ",
                              { t:7,
                                e:"tbody",
                                f:[ { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"th",
                                        f:[ { t:7,
                                            e:"i",
                                            a:{ "class":"icon-user" } } ] },
                                      " ",
                                      { t:7,
                                        e:"th",
                                        f:[ "Travelers" ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td" },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        f:[ "Booking Name: ",
                                          { t:2,
                                            r:"PlanningData.TravelerInfo.LiteralName" },
                                          " ",
                                          { t:7,
                                            e:"br" },
                                          " ",
                                          { t:2,
                                            x:{ r:[ "getTravelers",
                                                "." ],
                                              s:"_0(_1)" } },
                                          " ",
                                          { t:7,
                                            e:"br" },
                                          " ",
                                          { t:2,
                                            x:{ r:[ "getTravelerAges",
                                                "." ],
                                              s:"_0(_1)" } } ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"th",
                                        f:[ { t:7,
                                            e:"i",
                                            a:{ "class":"icon-calendar" } } ] },
                                      " ",
                                      { t:7,
                                        e:"th",
                                        f:[ "Arrive / Depart" ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td" },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        f:[ { t:2,
                                            x:{ r:[ "getFromTo",
                                                "." ],
                                              s:"_0(_1)" } },
                                          " ",
                                          { t:7,
                                            e:"br" },
                                          " (",
                                          { t:2,
                                            r:"PlanningData.Timeline.NightCount" },
                                          " Night",
                                          { t:4,
                                            f:[ "s" ],
                                            n:50,
                                            x:{ r:[ "PlanningData.Timeline.NightCount" ],
                                              s:"_0>1" } },
                                          ")" ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"th",
                                        f:[ { t:7,
                                            e:"i",
                                            a:{ "class":"icon-map-marker" } } ] },
                                      " ",
                                      { t:7,
                                        e:"th",
                                        f:[ "Destination" ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td" },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        f:[ { t:2,
                                            r:"Destination" },
                                          " ",
                                          { t:4,
                                            f:[ { t:7,
                                                e:"br" },
                                              " ",
                                              { t:4,
                                                n:53,
                                                f:[ { t:8,
                                                    r:"hotelRating" } ],
                                                r:"PlanningData.DestinationInfo.HotelCategory" } ],
                                            n:50,
                                            x:{ r:[ "PlanningData.DestinationInfo.HotelCategory" ],
                                              s:"_0!=\"\"" } } ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"th",
                                        f:[ { t:7,
                                            e:"i",
                                            a:{ "class":"icon-tag" } } ] },
                                      " ",
                                      { t:7,
                                        e:"th",
                                        f:[ "Hotel Room" ] } ] },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td" },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        f:[ { t:2,
                                            x:{ r:[ "getRoomName",
                                                "." ],
                                              s:"_0(_1)" } },
                                          " ",
                                          { t:7,
                                            e:"br" },
                                          " ",
                                          { t:2,
                                            x:{ r:[ "getHotelDescription",
                                                "." ],
                                              s:"_0(_1)" } } ] } ] },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"th",
                                            f:[ { t:7,
                                                e:"i",
                                                a:{ "class":"icon-tags" } } ] },
                                          " ",
                                          { t:7,
                                            e:"th",
                                            f:[ "Room Description" ] } ] },
                                      " ",
                                      { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td" },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            f:[ { t:3,
                                                x:{ r:[ "getRoomDescription",
                                                    "." ],
                                                  s:"_0(_1)" } } ] } ] } ],
                                    n:50,
                                    r:"PlanningData.DestinationInfo.RoomDescription" },
                                  " ",
                                  { t:7,
                                    e:"tr",
                                    f:[ { t:7,
                                        e:"td" },
                                      " ",
                                      { t:7,
                                        e:"td",
                                        f:[ "Average Nightly Rate: ",
                                          { t:7,
                                            e:"strong",
                                            f:[ { t:2,
                                                x:{ r:[ "formatMoney",
                                                    "PlanningData.DestinationInfo.Rate.RoomRateTotal",
                                                    "PlanningData.Timeline.NightCount" ],
                                                  s:"_0(_1/_2)" } } ] } ] } ] },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"tr",
                                        f:[ { t:7,
                                            e:"td" },
                                          " ",
                                          { t:7,
                                            e:"td",
                                            f:[ { t:7,
                                                e:"a",
                                                a:{ href:[ { t:2,
                                                      x:{ r:[ "getDetailLink",
                                                          "PlanningData.DestinationInfo.DestinationSourceID",
                                                          "PlanningData.Provider",
                                                          "PlanningData.DestinationInfo.VRegion.RegionName",
                                                          "PlanningData.DestinationInfo.VRegion.RegionID" ],
                                                        s:"_0(_1,_2,{value:_3,id:_4})" } } ],
                                                  "class":"btn" },
                                                f:[ { t:7,
                                                    e:"strong",
                                                    f:[ "Return to Room Selection" ] } ] } ] } ] } ],
                                    n:50,
                                    r:"data.CurrentlyBooking" } ] } ] } ] },
                      " ",
                      { t:7,
                        e:"div",
                        a:{ "class":"span12" },
                        f:[ { t:4,
                            f:[ { t:4,
                                f:[ { t:7,
                                    e:"button",
                                    a:{ "class":"btn btn-large btn-primary",
                                      type:"button",
                                      disabled:[ { t:2,
                                          r:"booking" } ] },
                                    v:{ click:"onBook" },
                                    f:[ { t:4,
                                        f:[ "Loading Confirmation..." ],
                                        n:50,
                                        r:"loadingReview" },
                                      { t:4,
                                        n:51,
                                        f:[ { t:4,
                                            n:50,
                                            x:{ r:[ "booking" ],
                                              s:"_0" },
                                            f:[ "Booking..." ] },
                                          { t:4,
                                            n:50,
                                            x:{ r:[ "booking" ],
                                              s:"!(_0)" },
                                            f:[ "BOOK THIS VACATION!" ] } ],
                                        r:"loadingReview" } ] } ],
                                n:50,
                                r:"data.IsValid" } ],
                            n:50,
                            r:"IsCurrentVacation" },
                          { t:4,
                            n:51,
                            f:[ { t:7,
                                e:"h4",
                                f:[ "Booked on ",
                                  { t:2,
                                    x:{ r:[ "formatDate",
                                        "CreateDate" ],
                                      s:"_0(_1,\"M/d/yyyy\")" } },
                                  " at ",
                                  { t:2,
                                    x:{ r:[ "formatDate",
                                        "CreateDate" ],
                                      s:"_0(_1,\"h:mm tt\")" } } ] },
                              { t:7,
                                e:"br" },
                              " ",
                              { t:4,
                                f:[ { t:7,
                                    e:"button",
                                    a:{ type:"button",
                                      "class":"btn btn-primary spaced" },
                                    v:{ click:"onBackToCurrentVacation" },
                                    f:[ "Back To Current Vacation" ] } ],
                                n:50,
                                r:"data.CurrentlyBooking" },
                              { t:4,
                                n:51,
                                f:[ { t:7,
                                    e:"button",
                                    a:{ type:"button",
                                      "class":"btn btn-primary",
                                      title:"This will recalculate your payment plan, using the shortage selections.",
                                      disabled:[ { t:2,
                                          r:"applying" } ] },
                                    v:{ click:"onApplyPlan" },
                                    f:[ { t:4,
                                        f:[ "Saving..." ],
                                        n:50,
                                        r:"applying" },
                                      { t:4,
                                        n:51,
                                        f:[ "Update Plan" ],
                                        r:"applying" } ] } ],
                                r:"data.CurrentlyBooking" } ],
                            r:"IsCurrentVacation" },
                          " ",
                          { t:4,
                            n:53,
                            f:[ { t:8,
                                r:"messenger" } ],
                            r:"data.GlobalMessenger" },
                          " ",
                          { t:4,
                            f:[ { t:7,
                                e:"br" },
                              { t:7,
                                e:"br" },
                              " ",
                              { t:7,
                                e:"a",
                                a:{ "class":"btn btn-primary",
                                  href:[ { t:2,
                                      r:"LinkAccountUrl" } ],
                                  "data-track":"ReviewBooking,LinkAccount_Bottom,Click,1" },
                                f:[ "Link My Bank Account" ] } ],
                            n:50,
                            x:{ r:[ "data.BankAccounts.length" ],
                              s:"_0===0" } } ] } ] } ],
                n:53,
                r:"activeVacation" } ],
            x:{ r:[ "activeVacation" ],
              s:"_0==null" } } ] } ],
    overageOptions:[ { t:7,
        e:"div",
        a:{ "class":"overageOptions" },
        f:[ { t:4,
            f:[ { t:4,
                f:[ { t:7,
                    e:"div",
                    a:{ "class":"spaced" },
                    f:[ { t:7,
                        e:"em",
                        f:[ "For ",
                          { t:2,
                            r:"vacation.PlanningData.VacationName" } ] } ] } ],
                n:50,
                r:"multipleVacations" },
              " ",
              { t:4,
                f:[ { t:7,
                    e:"div",
                    m:[ { t:4,
                        f:[ "class=\"overageOption\"" ],
                        n:50,
                        r:"multipleVacations" } ],
                    f:[ { t:7,
                        e:"input",
                        a:{ type:"radio",
                          name:[ "overageOptions_",
                            { t:2,
                              r:"vacation.DestinationId" },
                            "_",
                            { t:2,
                              r:"forTax" } ],
                          id:[ "o_",
                            { t:2,
                              r:"vacation.DestinationId" },
                            "_",
                            { t:2,
                              r:"@index" },
                            "_",
                            { t:2,
                              r:"forTax" } ],
                          checked:[ { t:2,
                              r:"Selected" } ] },
                        v:{ click:"onOverageSelect" } },
                      " ",
                      { t:7,
                        e:"label",
                        a:{ "for":[ "o_",
                            { t:2,
                              r:"vacation.DestinationId" },
                            "_",
                            { t:2,
                              r:"@index" },
                            "_",
                            { t:2,
                              r:"forTax" } ] },
                        f:[ { t:2,
                            r:"Description" } ] } ] },
                  " ",
                  { t:4,
                    f:[ { t:7,
                        e:"div",
                        a:{ "class":"bankAccount-select" },
                        f:[ { t:4,
                            f:[ { t:4,
                                f:[ { t:2,
                                    r:"Bank" },
                                  " - *",
                                  { t:2,
                                    r:"Last4" } ],
                                n:53,
                                r:"bankAccounts.0" } ],
                            n:50,
                            x:{ r:[ "bankAccounts.length" ],
                              s:"_0===1" } },
                          { t:4,
                            n:51,
                            f:[ { t:7,
                                e:"select",
                                a:{ value:[ { t:2,
                                      rx:{ r:"vacation.OverageOptions",
                                        m:[ { r:[ "forTax" ],
                                            s:"_0?\"BankIdTax\":\"BankIdNonTax\"" } ] } } ] },
                                f:[ { t:4,
                                    f:[ { t:7,
                                        e:"option",
                                        a:{ value:[ { t:2,
                                              r:"Id" } ] },
                                        f:[ { t:2,
                                            r:"Bank" },
                                          " - *",
                                          { t:2,
                                            r:"Last4" } ] } ],
                                    n:52,
                                    r:"bankAccounts" } ] },
                              " ",
                              { t:7,
                                e:"br" } ],
                            x:{ r:[ "bankAccounts.length" ],
                              s:"_0===1" } } ] } ],
                    n:50,
                    x:{ r:[ "ChooseAccount",
                        "Selected" ],
                      s:"_0&&_1" } } ],
                n:52,
                x:{ r:[ "getOverageOptionsByVac",
                    "vacation",
                    "forTax" ],
                  s:"_0(_1,_2?\"tax\":\"nonTax\")" } } ],
            n:50,
            x:{ r:[ "getOverageOptionsByVac",
                "vacation",
                "forTax" ],
              s:"_0(_1,_2?\"tax\":\"nonTax\")!=null" } } ] } ],
    bookingSuccess:[ { t:7,
        e:"div",
        a:{ "class":"bookSuccess" },
        f:[ { t:7,
            e:"h2",
            f:[ "Congratulations! You're booked and on your way!" ] },
          " ",
          { t:4,
            f:[ { t:7,
                e:"div",
                a:{ "class":"alert alert-info" },
                f:[ { t:7,
                    e:"strong",
                    f:[ "If your bank account is not verified within ",
                      { t:7,
                        e:"span",
                        a:{ style:"font-size:larger;" },
                        f:[ "4 days" ] },
                      ", we'll have to ",
                      { t:7,
                        e:"span",
                        a:{ style:"font-size:larger;" },
                        f:[ "cancel" ] },
                      " your booking." ] },
                  " ",
                  { t:7,
                    e:"br" },
                  { t:7,
                    e:"br" },
                  " ",
                  { t:7,
                    e:"a",
                    a:{ "class":"btn bnt-large btn-primary",
                      href:"/myaccount/FinancialAccount.aspx",
                      "data-track":"PostBooking,Verify_Link,Click,1" },
                    f:[ "Verify Bank Account" ] } ] } ],
            n:50,
            x:{ r:[ "hasApprovedLink" ],
              s:"!_0" } },
          " ",
          { t:8,
            r:"vacationDetails" },
          " ",
          { t:7,
            e:"a",
            a:{ href:"/#/vacations/",
              "class":"btn btn-primary" },
            f:[ "Review Vacations" ] } ] } ] } };});
